import React, { ReactNode } from "react";
import { InputLabel, InputLabelProps, Box } from "@mui/material";

type WcInputLabelProps = InputLabelProps & {
  children?: ReactNode;
};

export const WcInputLabel = (props: WcInputLabelProps) => (
  <Box id="WcInputLabel">
    <InputLabel {...props} />
  </Box>
);

export default WcInputLabel;
